const moment = require('moment')
const headerImg = require('assets/timecard_header.png')

module.exports = ({
  data,
  constants,
  name
}) => {

  const dates = [6, 5, 4, 3, 2, 1, 0]
    .map(offset => moment(data.timestamp)
      .subtract(offset, 'day')
      .format("M/DD"))

  const workedDay = [
    "8.0",
    "14.0",
    "14.5",
    "20.5",
    "12.0"
  ]

  const dayTotals = data.days.slice(1, 6).map(
    day => day === 'WORKED' ?
    workedDay : [
      day,
      "0.0",
      "0.0",
      "0.0",
      "0.0"
    ]
  )

  const hoursTotal = data.days.reduce(
    (acc, day) => day === 'WORKED' ? acc + 12 : acc,
    0
  ) + ".0"


  return (
    `
<html>

<head>
	<meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
<style>
	html {
		background: white;
	}
<!--table
	{mso-displayed-decimal-separator:"\.";
	mso-displayed-thousand-separator:"\,";}
@page
	{margin:.75in .25in .75in .25in;
	mso-header-margin:.3in;
	mso-footer-margin:.3in;
	mso-page-orientation:landscape;
	mso-horizontal-page-align:center;
	mso-vertical-page-align:center;}
.font8
	{color:black;
	font-size:12.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:Arial, sans-serif;
	mso-font-charset:0;}
.style0
	{
	text-align:general;
	vertical-align:bottom;
	white-space:nowrap;
	mso-rotate:0;
	mso-background-source:auto;
	mso-pattern:auto;
	color:black;
	font-size:10.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:Arial, sans-serif;
	mso-font-charset:0;
	border:none;
	mso-protection:locked visible;
	mso-style-name:Normal;
	mso-style-id:0;}
td
	{mso-style-parent:style0;
	padding:0px;
	mso-ignore:padding;
	color:black;
	font-size:10.0pt;
	font-weight:700;
	font-style:normal;
	text-decoration:none;
	font-family:Arial, sans-serif;
	mso-font-charset:0;
	text-align:general;
	vertical-align:bottom;
	border:none;
	mso-background-source:auto;
	mso-pattern:auto;
	mso-protection:locked visible;
	white-space:nowrap;
	mso-rotate:0;}
.xl68
	{mso-style-parent:style0;
	font-weight:400;}
.xl69
	{mso-style-parent:style0;
	font-size:6.0pt;
	font-weight:400;
	text-align:center;}
.xl70
	{mso-style-parent:style0;
	font-weight:400;
	border: 1px solid black;}
.xl71
	{mso-style-parent:style16;
	font-weight:400;
	border: 1px solid black;}
.xl72
	{mso-style-parent:style0;
	font-size:6.0pt;
	font-weight:400;}
.xl73
	{mso-style-parent:style16;
	font-size:9.0pt;
	font-weight:400;
	border: 1px solid black;}
.xl74
	{mso-style-parent:style0;
	font-weight:400;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl75
	{mso-style-parent:style0;
	font-size:14.0pt;
	text-align:center;
	vertical-align:middle;
	border: 1px solid black;}
.xl76
	{mso-style-parent:style0;
	font-weight:400;
	text-align:left;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl77
	{mso-style-parent:style0;
	font-size:6.0pt;
	vertical-align:middle;
	border: 1px solid black;}
.xl78
	{mso-style-parent:style0;
	font-size:8.0pt;
	font-weight:400;
	text-align:center;
	border: 1px solid black;}
.xl79
	{mso-style-parent:style0;
	font-size:12.0pt;
	text-align:right;
	vertical-align:middle;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl80
	{mso-style-parent:style0;
	font-size:6.0pt;
	text-align:center;
	border: 1px solid black;}
.xl81
	{mso-style-parent:style0;
	font-size:9.0pt;
	text-align:left;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl82
	{mso-style-parent:style0;
	font-size:9.0pt;
	text-align:right;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl83
	{mso-style-parent:style0;
	font-size:12.0pt;
	text-align:center;
	border: 1px solid black;}
.xl84
	{mso-style-parent:style0;
	font-size:14.0pt;
	text-align:center;
	border: 1px solid black;}
.xl85
	{mso-style-parent:style0;
	font-size:12.0pt;
	text-align:center;
	border: 1px solid black;
	background:yellow;
	mso-pattern:black none;}
.xl86
	{mso-style-parent:style0;
	text-align:center;
	border: 1px solid black;}
.xl87
	{mso-style-parent:style0;
	font-size:6.0pt;
	text-align:left;
	border: 1px solid black;}
.xl88
	{mso-style-parent:style0;
	text-align:left;
	border: 1px solid black;}
.xl89
	{mso-style-parent:style0;
	font-size:12.0pt;
	text-align:center;
	border: 1px solid black;}
.xl90
	{mso-style-parent:style0;
	font-size:14.0pt;
	text-align:center;
	vertical-align:middle;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl91
	{mso-style-parent:style0;
	text-align:center;
	vertical-align:middle;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl92
	{mso-style-parent:style0;
	font-size:14.0pt;
	text-decoration:underline;
	text-underline-style:single;
	text-align:center;
	vertical-align:middle;
	border: 1px solid black;}
.xl93
	{mso-style-parent:style0;
	font-size:11.0pt;
	text-align:center;
	border: 1px solid black;}
.xl94
	{mso-style-parent:style0;
	font-size:4.0pt;
	text-align:center;
	border: 1px solid black;}
.xl95
	{mso-style-parent:style0;
	font-weight:400;
	text-align:center;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl96
	{mso-style-parent:style0;
	font-weight:400;
	text-align:center;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl97
	{mso-style-parent:style0;
	text-align:center;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl98
	{mso-style-parent:style0;
	font-weight:400;
	text-align:center;
	border: 1px solid black;}
.xl99
	{mso-style-parent:style0;
	font-weight:400;
	text-align:center;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl100
	{mso-style-parent:style0;
	font-size:4.0pt;
	text-align:center;
	vertical-align:middle;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;
	layout-flow:vertical;}
.xl101
	{mso-style-parent:style0;
	font-size:6.0pt;
	text-align:center;
	border: 1px solid black;
	white-space:normal;}
.xl102
	{mso-style-parent:style0;
	font-weight:400;
	text-align:center;
	border: 1px solid black;
	background:yellow;
	mso-pattern:black none;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl103
	{mso-style-parent:style0;
	font-size:12.0pt;
	text-align:right;
	vertical-align:middle;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl104
	{mso-style-parent:style0;
	font-size:12.0pt;
	font-weight:400;
	font-family:"Arial Narrow", sans-serif;
	mso-font-charset:0;
	text-align:left;
	vertical-align:middle;
	border-top:1px solid black;
	border-right:none;
	border-bottom:1px solid black;
	border-left:1px solid black;
	mso-background-source:auto;
	mso-pattern:black none;}
.xl105
	{mso-style-parent:style0;
	vertical-align:middle;
	border-top:1px solid black;
	border-right:none;
	border-bottom:1px solid black;
	border-left:none;}
.xl106
	{mso-style-parent:style0;
	font-size:11.0pt;
	text-align:left;
	vertical-align:middle;
	border-top:1px solid black;
	border-right:none;
	border-bottom:1px solid black;
	border-left:none;
	mso-background-source:auto;
	mso-pattern:black none;}
.xl107
	{mso-style-parent:style0;
	border-top:1px solid black;
	border-right:none;
	border-bottom:1px solid black;
	border-left:none;}
.xl108
	{mso-style-parent:style0;
	border-top:1px solid black;
	border-right:1px solid black;
	border-bottom:1px solid black;
	border-left:none;}
.xl109
	{mso-style-parent:style0;
	font-size:9.0pt;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl110
	{mso-style-parent:style0;
	font-size:9.0pt;
	text-align:left;
	border-top:1px solid black;
	border-right:none;
	border-bottom:1px solid black;
	border-left:1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl111
	{mso-style-parent:style0;
	font-size:9.0pt;
	text-align:left;
	border-top:1px solid black;
	border-right:none;
	border-bottom:1px solid black;
	border-left:none;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl112
	{mso-style-parent:style0;
	font-size:9.0pt;
	text-align:left;
	border-top:1px solid black;
	border-right:1px solid black;
	border-bottom:1px solid black;
	border-left:none;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl113
	{mso-style-parent:style0;
	font-size:9.0pt;
	font-weight:400;
	text-align:left;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl114
	{mso-style-parent:style0;
	font-size:9.0pt;
	text-align:center;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl115
	{mso-style-parent:style17;
	font-size:9.0pt;
	font-weight:400;
	text-align:left;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl116
	{mso-style-parent:style17;
	font-size:9.0pt;
	font-weight:400;
	text-align:right;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl117
	{mso-style-parent:style17;
	font-size:9.0pt;
	font-weight:400;
	text-align:center;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl118
	{mso-style-parent:style0;
	font-size:9.0pt;
	font-weight:400;
	text-align:center;
	border: 1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl119
	{mso-style-parent:style0;
	font-size:14.0pt;
	font-weight:400;
	text-align:center;
	border-top:1px solid black;
	border-right:none;
	border-bottom:1px solid black;
	border-left:1px solid black;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl120
	{mso-style-parent:style0;
	font-size:14.0pt;
	font-weight:400;
	text-align:center;
	border-top:1px solid black;
	border-right:none;
	border-bottom:1px solid black;
	border-left:none;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl121
	{mso-style-parent:style0;
	font-size:14.0pt;
	font-weight:400;
	text-align:center;
	border-top:1px solid black;
	border-right:1px solid black;
	border-bottom:1px solid black;
	border-left:none;
	white-space:nowrap;
	mso-text-control:shrinktofit;}
.xl122
	{mso-style-parent:style0;
	font-size:12.0pt;
	font-weight:400;
	text-align:center;}
.xl123
	{mso-style-parent:style0;
	font-size:8.0pt;
	font-weight:400;
	text-align:left;
	border: 1px solid black;}
.xl124
	{mso-style-parent:style0;
	font-size:8.0pt;
	font-weight:400;
	font-family:"Matura MT Script Capitals", cursive;
	mso-font-charset:0;
	text-align:left;
	border: 1px solid black;}
.xl125
	{mso-style-parent:style0;
	font-size:8.0pt;
	font-weight:400;
	text-align:right;
	border-top:1px solid black;
	border-right:none;
	border-bottom:none;
	border-left:1px solid black;}
.xl126
	{mso-style-parent:style0;
	text-align:right;
	border-top:1px solid black;
	border-right:none;
	border-bottom:none;
	border-left:none;}
.xl127
	{mso-style-parent:style0;
	text-align:right;
	border-top:1px solid black;
	border-right:1px solid black;
	border-bottom:none;
	border-left:none;}
.xl128
	{mso-style-parent:style0;
	text-align:right;
	border-top:none;
	border-right:none;
	border-bottom:1px solid black;
	border-left:1px solid black;}
.xl129
	{mso-style-parent:style0;
	text-align:right;
	border-top:none;
	border-right:none;
	border-bottom:1px solid black;
	border-left:none;}
.xl130
	{mso-style-parent:style0;
	text-align:right;
	border-top:none;
	border-right:1px solid black;
	border-bottom:1px solid black;
	border-left:none;}
-->
</style>
</head>

<body link=blue vlink=purple class=xl68>

<table border=0 cellpadding=0 cellspacing=0 width=1305 style='border-collapse:
 collapse;table-layout:fixed;width:983pt'>
 <col class=xl68 width=24 style='mso-width-source:userset;mso-width-alt:768;
 width:18pt'>
 <col class=xl68 width=40 style='mso-width-source:userset;mso-width-alt:1280;
 width:30pt'>
 <col class=xl68 width=37 style='mso-width-source:userset;mso-width-alt:1194;
 width:28pt'>
 <col class=xl68 width=28 style='mso-width-source:userset;mso-width-alt:896;
 width:21pt'>
 <col class=xl68 width=35 style='mso-width-source:userset;mso-width-alt:1109;
 width:26pt'>
 <col class=xl68 width=29 style='mso-width-source:userset;mso-width-alt:938;
 width:22pt'>
 <col class=xl68 width=45 span=13 style='mso-width-source:userset;mso-width-alt:
 1450;width:34pt'>
 <col class=xl68 width=51 style='mso-width-source:userset;mso-width-alt:1621;
 width:38pt'>
 <col class=xl68 width=32 span=2 style='mso-width-source:userset;mso-width-alt:
 1024;width:24pt'>
 <col class=xl68 width=5 style='mso-width-source:userset;mso-width-alt:170;
 width:4pt'>
 <col class=xl68 width=35 style='mso-width-source:userset;mso-width-alt:1109;
 width:26pt'>
 <col class=xl68 width=36 style='mso-width-source:userset;mso-width-alt:1152;
 width:27pt'>
 <col class=xl68 width=37 style='mso-width-source:userset;mso-width-alt:1194;
 width:28pt'>
 <col class=xl68 width=29 style='mso-width-source:userset;mso-width-alt:938;
 width:22pt'>
 <col class=xl68 width=53 style='mso-width-source:userset;mso-width-alt:1706;
 width:40pt'>
 <col class=xl68 width=33 style='mso-width-source:userset;mso-width-alt:1066;
 width:25pt'>
 <col class=xl68 width=77 style='mso-width-source:userset;mso-width-alt:2474;
 width:58pt'>
 <col class=xl68 width=107 style='mso-width-source:userset;mso-width-alt:3413;
 width:80pt'>
 <tr height=81 style='mso-height-source:userset;height:61.5pt'>
  <td height=81 width=24 style='height:61.5pt;width:18pt' align=left
  valign=top><!--[if gte vml 1]><v:shapetype id="_x0000_t75" coordsize="21600,21600"
   o:spt="75" o:preferrelative="t" path="m@4@5l@4@11@9@11@9@5xe" filled="f"
   stroked="f">
   <v:stroke joinstyle="miter"/>
   <v:formulas>
    <v:f eqn="if lineDrawn pixelLineWidth 0"/>
    <v:f eqn="sum @0 1 0"/>
    <v:f eqn="sum 0 0 @1"/>
    <v:f eqn="prod @2 1 2"/>
    <v:f eqn="prod @3 21600 pixelWidth"/>
    <v:f eqn="prod @3 21600 pixelHeight"/>
    <v:f eqn="sum @0 0 1"/>
    <v:f eqn="prod @6 1 2"/>
    <v:f eqn="prod @7 21600 pixelWidth"/>
    <v:f eqn="sum @8 21600 0"/>
    <v:f eqn="prod @7 21600 pixelHeight"/>
    <v:f eqn="sum @10 21600 0"/>
   </v:formulas>
   <v:path o:extrusionok="f" gradientshapeok="t" o:connecttype="rect"/>
   <o:lock v:ext="edit" aspectratio="t"/>
  </v:shapetype><v:shape id="Picture_x0020_2" o:spid="_x0000_s1025" type="#_x0000_t75"
   alt="timecard" style='position:absolute;margin-left:0;margin-top:1pt;
   width:768pt;height:59pt;z-index:1;visibility:visible' o:gfxdata="${headerImg}">
   <v:imagedata src="${headerImg}" o:title=""/>
   <x:ClientData ObjectType="Pict">
    <x:SizeWithCells/>
    <x:CF>Bitmap</x:CF>
    <x:AutoPict/>
   </x:ClientData>
  </v:shape><![endif]--><![if !vml]><span style='mso-ignore:vglayout;
  position:absolute;z-index:1;margin-left:0px;margin-top:1px;width:1024px;
  height:79px'><img width=1024 height=79 src="${headerImg}"
  alt=timecard v:shapes="Picture_x0020_2"></span><![endif]><span
  style='mso-ignore:vglayout2'>
  <table cellpadding=0 cellspacing=0>
   <tr>
    <td height=81 class=xl68 width=24 style='height:61.5pt;width:18pt'><a
    name="Print_Area"></a></td>
   </tr>
  </table>
  </span></td>
  <td class=xl68 width=40 style='width:30pt'></td>
  <td class=xl68 width=37 style='width:28pt'></td>
  <td class=xl68 width=28 style='width:21pt'></td>
  <td class=xl68 width=35 style='width:26pt'></td>
  <td class=xl68 width=29 style='width:22pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=45 style='width:34pt'></td>
  <td class=xl68 width=51 style='width:38pt'></td>
  <td class=xl68 width=32 style='width:24pt'></td>
  <td class=xl68 width=32 style='width:24pt'></td>
  <td class=xl68 width=5 style='width:4pt'></td>
  <td class=xl68 width=35 style='width:26pt'></td>
  <td class=xl68 width=36 style='width:27pt'></td>
  <td class=xl68 width=37 style='width:28pt'></td>
  <td class=xl68 width=29 style='width:22pt'></td>
  <td class=xl68 width=53 style='width:40pt'></td>
  <td class=xl68 width=33 style='width:25pt'></td>
  <td class=xl68 width=77 style='width:58pt'></td>
  <td class=xl68 width=107 style='width:80pt'></td>
 </tr>
 <tr height=12 style='mso-height-source:userset;height:9.75pt'>
  <td colspan=10 height=12 class=xl87 style='height:9.75pt'>PICTURE</td>
  <td colspan=7 class=xl87 style='border-left:none'>PROD #</td>
  <td colspan=3 class=xl87 style='border-left:none'>GUAR. HOURS</td>
  <td colspan=7 class=xl87 style='border-left:none'>WEEK ENDING</td>
  <td colspan=2 class=xl87 style='border-left:none'>WORK CITY</td>
  <td colspan=2 class=xl87 style='border-left:none'>WORK STATE</td>
 </tr>
 <tr height=27 style='mso-height-source:userset;height:20.25pt'>
  <td colspan=10 height=27 class=xl83 style='height:20.25pt'>
		${constants.picture}
	</td>
  <td colspan=7 class=xl84 style='border-left:none'>&nbsp;</td>
  <td colspan=3 class=xl83 style='border-left:none'>NA</td>
  <td colspan=7 class=xl85 style='border-left:none'>
		${moment(data.timestamp).format('MM/DD/YY')}
	</td>
  <td colspan=2 class=xl83 style='border-left:none'>${constants.work_city}</td>
  <td colspan=2 class=xl83 style='border-left:none'>${constants.work_state}</td>
 </tr>
 <tr height=13 style='mso-height-source:userset;height:10.5pt'>
  <td colspan=10 height=13 class=xl87 style='height:10.5pt'>NAME</td>
  <td colspan=7 class=xl87 style='border-left:none'>SOCIAL SECURITY #</td>
  <td colspan=3 class=xl87 style='border-left:none'>UNION</td>
  <td colspan=7 class=xl87 style='border-left:none'>ACCOUNT #</td>
  <td colspan=4 class=xl87 style='border-left:none'>FRINGE ACCOUNT #</td>
 </tr>
 <tr height=27 style='mso-height-source:userset;height:20.25pt'>
  <td colspan=10 height=27 class=xl83 style='height:20.25pt'>
		${name.full.toUpperCase()}
	</td>
  <td colspan=7 class=xl89 style='border-left:none'>
		xxx-xx-${constants.ssn_last_4}
	</td>
  <td colspan=3 class=xl83 style='border-left:none'>
		${constants.union}
	</td>
  <td colspan=7 class=xl84 style='border-left:none'>
		${constants.account_num}
	</td>
  <td colspan=4 class=xl84 style='border-left:none'>&nbsp;</td>
 </tr>
 <tr height=13 style='mso-height-source:userset;height:10.5pt'>
  <td colspan=10 height=13 class=xl87 style='height:10.5pt'>LOAN OUT</td>
  <td colspan=7 class=xl87 style='border-left:none'>FEDERAL I.D. #</td>
  <td colspan=3 class=xl87 style='border-left:none'>STUDIO/DISTANT</td>
  <td colspan=4 class=xl80 style='border-left:none'>ON PRODUCTION</td>
  <td colspan=3 class=xl80 style='border-left:none'>OFF PRODUCITON</td>
  <td colspan=4 class=xl87 style='border-left:none'>OCCUPATION/ OCC CODE</td>
 </tr>
 <tr height=27 style='mso-height-source:userset;height:20.25pt'>
  <td colspan=10 height=27 class=xl84 style='height:20.25pt'>&nbsp;</td>
  <td colspan=7 class=xl89 style='border-left:none'>&nbsp;</td>
  <td class=xl75 style='border-top:none;border-left:none'>S</td>
  <td colspan=2 class=xl90 style='border-left:none'>&nbsp;</td>
  <td colspan=4 class=xl92 style='border-left:none'>X</td>
  <td colspan=3 class=xl92 style='border-left:none'><u style='visibility:hidden;
  mso-ignore:visibility'>&nbsp;</u></td>
  <td colspan=4 class=xl93 style='border-left:none'>
		${constants.occupation}
	</td>
 </tr>
 <tr class=xl69 height=17 style='mso-height-source:userset;height:13.5pt'>
  <td rowspan=2 height=30 class=xl80 style='height:23.5pt;border-top:none'>S/D</td>
  <td colspan=2 rowspan=2 class=xl80>DATE</td>
  <td rowspan=2 class=xl80 style='border-top:none'>DAY</td>
  <td colspan=2 rowspan=2 class=xl80>CALL</td>
  <td colspan=2 class=xl80 style='border-left:none'>1st MEAL</td>
  <td colspan=2 class=xl80 style='border-left:none'>2nd MEAL</td>
  <td rowspan=2 class=xl80 style='border-top:none'>WRAP</td>
  <td colspan=2 class=xl80 style='border-left:none'>RERATE</td>
  <td class=xl80 style='border-top:none;border-left:none'>Total</td>
  <td rowspan=2 class=xl80 style='border-top:none'>1X</td>
  <td rowspan=2 class=xl80 style='border-top:none'>1.5X</td>
  <td rowspan=2 class=xl80 style='border-top:none'>2X</td>
  <td rowspan=2 class=xl80 style='border-top:none'>250</td>
  <td rowspan=2 class=xl80 style='border-top:none'>&nbsp;</td>
  <td class=xl80 style='border-top:none;border-left:none'>MEAL</td>
  <td colspan=4 rowspan=2 class=xl80>ACCOUNT #</td>
  <td rowspan=2 class=xl80 style='border-top:none'>SER</td>
  <td rowspan=2 class=xl80 style='border-top:none'>LOC</td>
  <td rowspan=2 class=xl80 style='border-top:none'>SET</td>
  <td rowspan=2 class=xl101 width=53 style='border-top:none;width:40pt'>PAY
  CODE</td>
  <td rowspan=2 class=xl80 style='border-top:none'>HRS</td>
  <td rowspan=2 class=xl80 style='border-top:none'>RATE</td>
  <td rowspan=2 class=xl80 style='border-top:none'>AMOUNT</td>
 </tr>
 <tr class=xl69 height=13 style='height:10.0pt'>
  <td height=13 class=xl80 style='height:10.0pt;border-top:none;border-left:
  none'>OUT</td>
  <td class=xl80 style='border-top:none;border-left:none'>IN</td>
  <td class=xl80 style='border-top:none;border-left:none'>OUT</td>
  <td class=xl80 style='border-top:none;border-left:none'>IN</td>
  <td class=xl80 style='border-top:none;border-left:none'>RATE</td>
  <td class=xl80 style='border-top:none;border-left:none'>OCC</td>
  <td class=xl80 style='border-top:none;border-left:none'>Hrs</td>
  <td class=xl80 style='border-top:none;border-left:none'>PENALTY</td>
 </tr>

 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td rowspan=2 height=38 class=xl95 style='height:28.0pt;border-top:none'>&nbsp;</td>
  <td colspan=2 rowspan=2 class=xl99>${dates[0]}</td>
  <td rowspan=2 class=xl95 style='border-top:none'>S</td>
  <td colspan=2 rowspan=2 class=xl96>&nbsp;</td>
  <td rowspan=2 class=xl100 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>0.0</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td colspan=4 rowspan=2 class=xl98>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl78 style='border-top:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl74 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl73 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td height=19 class=xl70 style='height:14.0pt;border-top:none;border-left:
  none'>&nbsp;</td>
  <td class=xl76 style='border-top:none;border-left:none'>100</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td rowspan=2 height=38 class=xl95 style='height:28.0pt;border-top:none'>&nbsp;</td>
  <td colspan=2 rowspan=2 class=xl99>${dates[1]}</td>
  <td rowspan=2 class=xl95 style='border-top:none'>M</td>
  <td colspan=2 rowspan=2 class=xl102>
		${dayTotals[0][0]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[0][1]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[0][2]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[0][3]}
	</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[0][4]}
	</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td colspan=4 rowspan=2 class=xl98>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl78 style='border-top:none'>&nbsp;</td>
  <td class=xl76 style='border-top:none;border-left:none'>150</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td height=19 class=xl70 style='height:14.0pt;border-top:none;border-left:
  none'>&nbsp;</td>
  <td class=xl76 style='border-top:none;border-left:none'>200</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td rowspan=2 height=38 class=xl95 style='height:28.0pt;border-top:none'>&nbsp;</td>
  <td colspan=2 rowspan=2 class=xl99>${dates[2]}</td>
  <td rowspan=2 class=xl95 style='border-top:none'>T</td>
  <td colspan=2 rowspan=2 class=xl102>
		${dayTotals[1][0]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[1][1]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[1][2]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[1][3]}
	</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[1][4]}
	</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td colspan=4 rowspan=2 class=xl98>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl78 style='border-top:none'>&nbsp;</td>
  <td class=xl74 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td height=19 class=xl70 style='height:14.0pt;border-top:none;border-left:
  none'>&nbsp;</td>
  <td class=xl74 style='border-top:none;border-left:none'>Holna</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td rowspan=2 height=38 class=xl95 style='height:28.0pt;border-top:none'>&nbsp;</td>
  <td colspan=2 rowspan=2 class=xl99>${dates[3]}</td>
  <td rowspan=2 class=xl95 style='border-top:none'>W</td>
  <td colspan=2 rowspan=2 class=xl102>
		${dayTotals[2][0]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[2][1]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[2][2]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[2][3]}
	</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[2][4]}
	</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td colspan=4 rowspan=2 class=xl98>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl78 style='border-top:none'>&nbsp;</td>
  <td class=xl74 style='border-top:none;border-left:none'>Holna15</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td height=19 class=xl70 style='height:14.0pt;border-top:none;border-left:
  none'>&nbsp;</td>
  <td class=xl74 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td rowspan=2 height=38 class=xl95 style='height:28.0pt;border-top:none'>&nbsp;</td>
  <td colspan=2 rowspan=2 class=xl99>${dates[4]}</td>
  <td rowspan=2 class=xl95 style='border-top:none'>T</td>
  <td colspan=2 rowspan=2 class=xl102>
		${dayTotals[3][0]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[3][1]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[3][2]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[3][3]}
	</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[3][4]}
	</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td colspan=4 rowspan=2 class=xl98>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl78 style='border-top:none'>&nbsp;</td>
  <td class=xl74 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td height=19 class=xl70 style='height:14.0pt;border-top:none;border-left:
  none'>&nbsp;</td>
  <td class=xl74 style='border-top:none;border-left:none'>Sickpay</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td rowspan=2 height=38 class=xl95 style='height:28.0pt;border-top:none'>&nbsp;</td>
  <td colspan=2 rowspan=2 class=xl99>${dates[5]}</td>
  <td rowspan=2 class=xl95 style='border-top:none'>F</td>
  <td colspan=2 rowspan=2 class=xl102>
		${dayTotals[4][0]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[4][1]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[4][2]}
	</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[4][3]}
	</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>
		${dayTotals[4][4]}
	</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td colspan=4 rowspan=2 class=xl98>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl78 style='border-top:none'>&nbsp;</td>
  <td class=xl74 style='border-top:none;border-left:none'>Sick15</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td height=19 class=xl70 style='height:14.0pt;border-top:none;border-left:
  none'>&nbsp;</td>
  <td class=xl74 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td rowspan=2 height=38 class=xl95 style='height:28.0pt;border-top:none'>&nbsp;</td>
  <td colspan=2 rowspan=2 class=xl99>${dates[6]}</td>
  <td rowspan=2 class=xl95 style='border-top:none'>S</td>
  <td colspan=2 rowspan=2 class=xl96>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl95 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl96 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td colspan=4 rowspan=2 class=xl98>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl98 style='border-top:none'>&nbsp;</td>
  <td rowspan=2 class=xl78 style='border-top:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=19 style='mso-height-source:userset;height:14.0pt'>
  <td height=19 class=xl70 style='height:14.0pt;border-top:none;border-left:
  none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl71 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=43 style='mso-height-source:userset;height:32.25pt'>
  <td colspan=13 height=43 class=xl103 style='height:32.25pt'>TOTAL</td>
  <td class=xl79 style='border-top:none;border-left:none'>
		${hoursTotal}
	</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl77 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl77 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl78 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl70 style='border-top:none;border-left:none'>&nbsp;</td>
  <td class=xl73 style='border-top:none;border-left:none'>&nbsp;</td>
 </tr>
 <tr height=43 style='mso-height-source:userset;height:32.25pt'>
  <td colspan=3 height=43 class=xl104 style='height:32.25pt'>Comments:</td>
  <td colspan=28 class=xl106 style='border-right:1px solid black'>&nbsp;</td>
 </tr>
 <tr class=xl72 height=24 style='mso-height-source:userset;height:18.75pt'>
  <td colspan=4 height=24 class=xl81 style='height:18.75pt'>PER DIEM<span
  style='mso-spacerun:yes'>&nbsp; </span>ACCT#</td>
  <td colspan=4 class=xl81 style='border-left:none'>HOUSING<span
  style='mso-spacerun:yes'>&nbsp; </span>ACCT#</td>
  <td colspan=3 class=xl81 style='border-left:none'>ADVANCE</td>
  <td colspan=4 class=xl81 style='border-left:none'>MEAL MONEY</td>
  <td colspan=4 class=xl81 style='border-left:none'>MILEAGE</td>
  <td colspan=4 class=xl81 style='border-left:none'>CAR ALLOWANCE</td>
  <td colspan=4 class=xl81 style='border-left:none'>REIMBURSE</td>
  <td colspan=4 class=xl81 style='border-left:none'>EQP/BOX RENTAL</td>
 </tr>
 <tr class=xl72 height=24 style='mso-height-source:userset;height:18.75pt'>
  <td colspan=4 height=24 class=xl81 style='height:18.75pt'>&nbsp;</td>
  <td colspan=4 class=xl81 style='border-left:none'>&nbsp;</td>
  <td colspan=3 class=xl81 style='border-left:none'>ACCOUNT #</td>
  <td colspan=4 class=xl81 style='border-left:none'>ACCOUNT #</td>
  <td colspan=4 class=xl81 style='border-left:none'>ACCOUNT #</td>
  <td colspan=4 class=xl81 style='border-left:none'>ACCOUNT #</td>
  <td colspan=4 class=xl81 style='border-left:none'>ACCOUNT #</td>
  <td class=xl81 style='border-top:none;border-left:none'>ACCT.#</td>
  <td colspan=3 class=xl110 style='border-right:1px solid black;border-left:
  none'>&nbsp;</td>
 </tr>
 <tr class=xl72 height=24 style='mso-height-source:userset;height:18.75pt'>
  <td colspan=4 height=24 class=xl81 style='height:18.75pt'>TAXABLE</td>
  <td colspan=4 class=xl81 style='border-left:none'>TAXABLE</td>
  <td colspan=3 class=xl118 style='border-left:none'>&nbsp;</td>
  <td colspan=4 class=xl118 style='border-left:none'>&nbsp;</td>
  <td colspan=4 class=xl119 style='border-right:1px solid black;border-left:
  none'>&nbsp;</td>
  <td colspan=4 class=xl113 style='border-left:none'>&nbsp;</td>
  <td colspan=4 class=xl113 style='border-left:none'>&nbsp;</td>
  <td colspan=3 class=xl81 style='border-left:none'>TAXABLE</td>
  <td class=xl81 style='border-top:none;border-left:none'>NO WITHHOLDING</td>
 </tr>
 <tr class=xl72 height=24 style='mso-height-source:userset;height:18.75pt'>
  <td colspan=4 height=24 class=xl82 style='height:18.75pt'>PER</td>
  <td colspan=4 class=xl116 style='border-left:none'>&nbsp;</td>
  <td colspan=3 rowspan=2 class=xl117>&nbsp;</td>
  <td colspan=4 rowspan=2 class=xl118>&nbsp;</td>
  <td colspan=2 class=xl81 style='border-left:none'>TAXABLE</td>
  <td colspan=2 class=xl81 style='border-left:none'>NON-TAX</td>
  <td colspan=4 rowspan=2 class=xl115>&nbsp;</td>
  <td colspan=4 rowspan=2 class=xl115>&nbsp;</td>
  <td colspan=3 rowspan=2 class=xl113>&nbsp;</td>
  <td rowspan=2 class=xl114 style='border-top:none'>&nbsp;</td>
 </tr>
 <tr class=xl72 height=24 style='mso-height-source:userset;height:18.75pt'>
  <td colspan=4 height=24 class=xl81 style='height:18.75pt'>NONTAX</td>
  <td colspan=4 class=xl81 style='border-left:none'>NONTAX</td>
  <td colspan=2 class=xl115 style='border-left:none'>&nbsp;</td>
  <td colspan=2 class=xl115 style='border-left:none'>&nbsp;</td>
 </tr>
 <tr class=xl72 height=24 style='mso-height-source:userset;height:18.75pt'>
  <td colspan=4 height=24 class=xl82 style='height:18.75pt'>PD1</td>
  <td colspan=4 class=xl82 style='border-left:none'>PD2</td>
  <td colspan=3 class=xl82 style='border-left:none'>ADV</td>
  <td colspan=4 class=xl82 style='border-left:none'>MVA</td>
  <td colspan=2 class=xl82 style='border-left:none'>MLG</td>
  <td colspan=2 class=xl82 style='border-left:none'>ML1</td>
  <td colspan=4 class=xl82 style='border-left:none'>CRA</td>
  <td colspan=4 class=xl82 style='border-left:none'>EXPENSES</td>
  <td colspan=3 class=xl82 style='border-left:none'>EQP</td>
  <td class=xl82 style='border-top:none;border-left:none'>EQR</td>
 </tr>
 <tr class=xl72 height=17 style='mso-height-source:userset;height:13.5pt'>
  <td colspan=3 height=17 class=xl123 style='height:13.5pt'>EMPLOYEE</td>
  <td colspan=14 rowspan=2 class=xl124>&nbsp;</td>
  <td colspan=3 rowspan=2 class=xl125 style='border-right:1px solid black;
  border-bottom:1px solid black'>APPROVED<span style='mso-spacerun:yes'>&nbsp;
  </span><font class="font8">X</font></td>
  <td colspan=11 rowspan=2 class=xl88>&nbsp;</td>
 </tr>
 <tr class=xl72 height=23 style='mso-height-source:userset;height:17.25pt'>
  <td colspan=3 height=23 class=xl123 style='height:17.25pt'>SIGNATURE<span
  style='mso-spacerun:yes'>&nbsp;&nbsp; </span><font class="font8">X</font></td>
 </tr>
 <tr class=xl72 height=28 style='mso-height-source:userset;height:21.75pt'>
  <td colspan=31 height=28 class=xl122 style='height:21.75pt'>IF NO HOURS ARE
  INDICATED, TIME WILL BE COMPUTED AS UNION GUARANTEE</td>
 </tr>
 <tr class=xl72 height=16 style='mso-height-source:userset;height:12.5pt'>
  <td height=16 class=xl72 style='height:12.5pt'></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
 </tr>
 <tr class=xl72 height=16 style='mso-height-source:userset;height:12.5pt'>
  <td height=16 class=xl72 style='height:12.5pt'></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
 </tr>
 <tr class=xl72 height=16 style='mso-height-source:userset;height:12.5pt'>
  <td height=16 class=xl72 style='height:12.5pt'></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
 </tr>
 <tr class=xl72 height=16 style='mso-height-source:userset;height:12.5pt'>
  <td height=16 class=xl72 style='height:12.5pt'></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
 </tr>
 <tr class=xl72 height=16 style='mso-height-source:userset;height:12.5pt'>
  <td height=16 class=xl72 style='height:12.5pt'></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
 </tr>
 <tr class=xl72 height=16 style='mso-height-source:userset;height:12.5pt'>
  <td height=16 class=xl72 style='height:12.5pt'></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
 </tr>
 <tr class=xl72 height=13 style='height:10.0pt'>
  <td height=13 class=xl72 style='height:10.0pt'></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
 </tr>
 <tr class=xl72 height=13 style='height:10.0pt'>
  <td height=13 class=xl72 style='height:10.0pt'></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
 </tr>
 <tr class=xl72 height=13 style='height:10.0pt'>
  <td height=13 class=xl72 style='height:10.0pt'></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
  <td class=xl72></td>
 </tr>
</table>

</body>

</html>



`
  )


}


// WEBPACK FOOTER //
// ./src/templates/timecard.js